import './FieldNodeList.scss';
import React from 'react';
import { FieldNode } from './FieldNode';
export const FieldNodeList = ({ label = 'Nodes', nodes }) => {
    if (!nodes.length) {
        return null;
    }
    return (React.createElement("div", { className: 'field-node-container', "data-after-content": label }, nodes && nodes.map((node) => React.createElement(FieldNode, Object.assign({}, node, { key: node.name })))));
};
